import img1 from "../../assets/Images/Reports/Sound-Reports.png"

export default function SoundSystemReport() {
    return (
        <section id="sound-system-report" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    5. Sound System Report
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    The Sound System Report provides a portion-wise summary of events where
                    the sound system service was booked during a selected month and year.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        This report is used to analyze sound system usage across different
                        banquet halls (portions). It helps management understand demand,
                        plan equipment allocation, and evaluate service utilization trends.
                    </p>
                </section>
            </section>

            {/* FILTER */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Month & Year Filter
                    </h3>
                    <p className="text-slate-600 mb-3">
                        The Sound System Report is filtered by selecting a specific month
                        and year.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Select Month </li>
                        <li>Select Year</li>
                        <li>Filter applies to listing and totals simultaneously</li>
                    </ul>
                </div>
            </section>

            {/* TABLE */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-3">
                    Portion-wise Sound Booking Table
                </h3>

                <p className="text-slate-600 mb-4">
                    The table displays the total number of bookings where the sound system
                    service was used, grouped by banquet portion.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Portion Name (Hall)</li>
                    <li>Total sound system bookings for that portion</li>
                    <li>Data reflects confirmed bookings only</li>
                </ul>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* SEARCH */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Search Functionality
                </h3>

                <p className="text-slate-600 mb-3">
                    The search box allows users to quickly locate a specific portion
                    within the report.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Search by portion name</li>
                    <li>Instant filtering of table rows</li>
                    <li>Useful when managing multiple halls</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why This Report Matters
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    By reviewing sound system usage, management can identify high-demand
                    portions, optimize equipment availability, and plan maintenance or
                    upgrades based on actual usage patterns.
                </p>
            </section>

        </section>
    );
}
